export const CREATE_ITEMMAP = 'CREATE_ITEMMAP'
export const SAVED_ITEMMAP = 'SAVED_ITEMMAP'
export const EDIT_ITEMMAP = 'EDIT_ITEMMAP'
export const EDITED_ITEMMAP = 'EDITED_ITEMMAP'
export const FETCH_ITEMMAP = 'FETCH_ITEMMAP'
export const FETCHED_ITEMMAP = 'FETCHED_ITEMMAP'
export const SEARCH_ITEMMAP = 'SEARCH_ITEMMAP'
export const STORE_SEARCH_ITEMMAP_RESULT = 'STORE_SEARCH_ITEMMAP_RESULT'
export const DELETE_ITEMMAP = 'DELETE_ITEMMAP'
export const DELETED_ITEMMAP = 'DELETED_ITEMMAP'
export const NOTIFICATION_DONE_ITEMMAP = 'NOTIFICATION_DONE_ITEMMAP'
export const FILTER_ITEMS = 'FILTER_ITEMS'
